import { format } from 'date-fns'

export const formatDate = (timeframe: number) =>
  format(timeframe, 'dd.MM.yyyy HH:mm')

/** A calendar day in words, e.g. 19 November 2026. */
export const formatLongDate = (time: number) => format(time, 'd MMMM yyyy')
